<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Buyer
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                dense
                label="Name *"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                dense
                label="Primary Email *"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="status"
                outlined
                dense
                v-model="form.status"
                :items="approvalStatuses"
                label="Approval Status *"
                prepend-inner-icon="mdi-earth"
                :error-messages="errors.status"
              ></v-autocomplete>
            </v-col>
            

            
          </v-row>
          <v-row>

            <v-col sm="4">
              <v-text-field
                v-model="form.contact_no"
                outlined
                dense
                label="Contact No"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.contact_no"
              ></v-text-field>
            </v-col>

          </v-row>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Buyer
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "vendorGroupEditPage",
  data() {
    return {
      form: {
        name: "",
        email: "",
        status: "",
        contact_no: "",
      },
      approvalStatuses: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
      isLoading: false,
      errors: {
        name: null,
        email: null,
        status: null,
        contact_no: null,
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const encryptedId = this.$route.params.buyerId;
      try {
        const response = await axios.get(`/vendors/${encryptedId}`);
        this.form = response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      this.isLoading = true;
      try {
        await axios.post("/vendors", this.form);
        this.$router.push("/vendors");
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
        } else {
          console.error("Error saving data:", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
